/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Steps_Tool_Calls_CountInputs */



/**
* | output |
* | --- |
* | "{count} tool calls" |
*
* @param {Chat_Steps_Tool_Calls_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_steps_tool_calls_count = /** @type {((inputs: Chat_Steps_Tool_Calls_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Steps_Tool_Calls_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Tool-Aufrufe`)
	return /** @type {LocalizedString} */ (`${i?.count} tool calls`)
});